export class ContactEngagement {
    static jsonMap = {
        id: { key: 'id', optional: true },
        nom: { key: 'nom', optional: true },
        prenom: { key: 'prenom', optional: true }
    };

    public id: number = undefined;
    public nom: string = undefined;
    public prenom: string = undefined;
}
